<script setup lang="ts">
import HashGlobeView from "@/views/HashGlobeView.vue";
</script>

<template>
  <HashGlobeView />
</template>

<style lang="scss">
@use "@/assets/base.scss";
</style>
